// ✏️  Edita los textos entre comillas
// ➕  Para agregar una opción, copia un bloque { } y pégalo
// ⚠️  No elimines llaves { }, corchetes [ ] ni comas ,

export const DASHBOARD = {
  mensaje: '¿Qué necesitas saber del Dashboard?',
  opciones: [
    {
      boton: '¿Dónde está el Dashboard?',
      respuesta: 'El Dashboard está disponible desde el ícono de inicio en el menú lateral. Muestra métricas e indicadores generales del sistema.',
    },
    {
      boton: 'Los datos no se actualizan',
      respuesta: 'Los indicadores del Dashboard se actualizan cada vez que ingresas. Si los datos parecen desactualizados, recarga la página (F5).',
    },
  ],
}
